import { render, staticRenderFns } from "./QuestionParagraphs.vue?vue&type=template&id=0487d336&"
import script from "./QuestionParagraphs.vue?vue&type=script&lang=js&"
export * from "./QuestionParagraphs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports